import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import DynamicMultiSelector from "components/Molecules/DynamicMultiSelector"
import FormController from "components/Molecules/FormController"
import { AppPermissions } from "constants/permissions"
import {
  useFarmerGroupsAndCompaniesLazyQuery,
  useUpdateFarmerGroupsCompaniesMutation,
} from "generated/graphql"
import { COMPANIES, GROUPS } from "graphql/selector.queries.gql"
import useAuthorization from "hooks/useAuthorization"
import React, { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import AppToaster from "utils/AppToaster"
const UpdateFarmerGroupsCompanies = () => {
  const [params, setParams] = useSearchParams()
  const farmerId = parseInt(params.get("id"))
  const [state, setState] = useState({
    companies: [],
    groups: [],
  })

  const [fetchFarmer, { data, loading: uLoading }] =
    useFarmerGroupsAndCompaniesLazyQuery()
  const canUpdateSupplierGroups = useAuthorization([
    AppPermissions.canUpdateSupplierGroups,
  ])

  const canUpdateSupplierCompanies = useAuthorization([
    AppPermissions.canUpdateSupplierCompanies,
  ])

  const [updateFarmerGroups, { loading }] =
    useUpdateFarmerGroupsCompaniesMutation({
      onCompleted() {
        AppToaster.show({
          message: "Farmer updated successfully",
          intent: "success",
        })
        handleClose()
      },
      onError: () => {
        AppToaster.show({
          message: "Unable to update the farmer",
          intent: "danger",
        })
      },
    })
  const updateGroup =
    params.get("action") === "update-group" && canUpdateSupplierGroups
  const updateCompany =
    params.get("action") === "update-company" && canUpdateSupplierCompanies
  const isOpen = updateGroup || updateCompany

  useEffect(() => {
    if (isOpen && farmerId) {
      fetchFarmer({
        variables: {
          id: farmerId,
        },
      })
    }
  }, [isOpen, farmerId])

  useEffect(() => {
    if (data?.userDetails?.id) {
      setState({
        companies: data.userDetails.companies,
        groups: data.userDetails.groups,
      })
    }
  }, [data])

  function handleClose() {
    params.delete("action")
    params.delete("id")
    setParams(params)
  }
  return (
    <CustomDialog
      light
      width="60%"
      scrollable={false}
      footerRightButton={
        <CustomButton
          disabled={!canUpdateSupplierGroups && !canUpdateSupplierCompanies}
          loading={uLoading || loading}
          onClick={() => {
            if (!farmerId) return
            updateFarmerGroups({
              variables: {
                id: farmerId.toString(),
                companies: updateGroup
                  ? undefined
                  : state.companies.map(c => c.id),
                groups: updateCompany ? undefined : state.groups.map(g => g.id),
              },
            })
          }}
          dark
          icon="endorsed"
        >
          Confirm
        </CustomButton>
      }
      isOpen={isOpen}
      onClose={handleClose}
      icon={updateGroup ? "people" : updateCompany ? "office" : "edit"}
      title={
        updateGroup
          ? "Update Farmer Groups"
          : updateCompany
          ? "Update Farmer Companies"
          : "Update Farmer"
      }
    >
      <FormController
        source={state}
        onChange={(path, value) => {
          setState(prev => ({
            ...prev,
            [path]: value,
          }))
        }}
      >
        {updateCompany && (
          <DynamicMultiSelector
            query={COMPANIES}
            path="companies"
            fill
            label="Companies"
            required
            helperText={"eg. SFPCL"}
          />
        )}
        {updateGroup && (
          <DynamicMultiSelector
            required
            formClassName="col-span-3"
            query={GROUPS}
            variables={{
              category: "EXT",
            }}
            path="groups"
            fill={true}
            label="Groups"
            tagProps={name => {
              const group = data?.userDetails?.groups?.find(
                g => g.name === name
              )
              if (group?.category?.codename === "EXT") {
                return null
              } else {
                return {
                  interactive: false,
                  onRemove: () => {
                    AppToaster.show({
                      intent: "warning",
                      message: "Cant Remove Non-External Groups!",
                    })
                  },
                  minimal: true,
                  intent: "warning",
                }
              }
            }}
          />
        )}
      </FormController>
    </CustomDialog>
  )
}

export default UpdateFarmerGroupsCompanies
